import React from "react";
import "./seats.css";
import { connect } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import { getTableData, getTableReserved } from "../AddTable/Table.action";
import { isEmpty } from "lodash";
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const DrawGrid = (props) => {
  const onClickSeat = (seat) => {
    props.onClickData(seat);
  };
  return (
    <Container fluid>
      {props.isFetchingTable ? (
        <GlobalSpinner />
      ) : (
        <div className="container">
          <table className="grid">
            <tbody>
              <tr>
                {!isEmpty(props.seat) ? (
                  props.seat.map((row) =>
                  (
                    <td
                      key={row._id}
                      //disabled={true}
                      onClick={(e) =>
                        props.checktrue(row) ? onClickSeat(row) : null
                      }
                    // style={{dis}}
                    >
                      {/* <Image src={tablelogo} /> */}
                      {row.tableName}
                      <p>{row.tableSittingCapacity}</p>

                      {!isEmpty(props.tableListReserved)
                        ? props.tableListReserved.map((x) =>
                          x.tableId == row._id ? <p style={{ marginTop: '-15%' }}> Reserved <span>{x.status}</span></p> : "") : ""}
                    </td>
                  ))
                ) : (
                  <Row>
                    <Col xl="12" lg="12" md="12" sm="12" className="d-flex justify-content-center mt-2 mb-2"
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "red",
                      }}
                    >
                      No Table added Yet
                    </Col>
                  </Row>
                )}
              </tr>
            </tbody>
          </table>
          <div hidden={isEmpty(props.seat) ? true : false}>
            {/* <Row>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                className="d-flex justify-content-center mt-2 mb-2"
              >
                <Link to={"/pos"}>
                  <Button
                    onClick={() => props.handleSubmited()}
                    style={{ marginRight: 20 }}
                  >
                    Confirm Booking
                  </Button>
                </Link>
              </Col>
            </Row> */}
          </div>
        </div>
      )}
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTable: () => dispatch(getTableData()),
    getReservedTable: () => dispatch(getTableReserved()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  tableDataList: state.TableReducer.tableDataList,
  tableListReserved: state.TableReducer.tableListReserved,
  isFetchingTable: state.TableReducer.isFetchingTable,
});

export default connect(mapStateToProps, mapDispatchToProps)(DrawGrid);